export default __webpack_public_path__ + "static/Arrow-Recovery-App-3f351dfd3d08698d5a4ac2762d2a4ca9.webp";